import { useEffect, useState } from 'react';

function CalendlyField(
    { 
        field, 
        onBookingScheduled,
        name,
        email,
        phone,
        address,
        formId 
    }) {
  const [calendlyReady, setCalendlyReady] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Detect mobile device
  useEffect(() => {
    const checkMobile = () => {
      const mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) 
        || window.innerWidth < 768;
      setIsMobile(mobile);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    // Check if Calendly is already loaded
    if (window.Calendly) {
      console.log('Calendly already loaded');
      setCalendlyReady(true);
      return;
    }

    console.log('Loading Calendly script...');
    
    // Load Calendly CSS first
    const link = document.createElement('link');
    link.href = 'https://assets.calendly.com/assets/external/widget.css';
    link.rel = 'stylesheet';
    document.head.appendChild(link);

    // Then load Calendly JS
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    
    script.onload = () => {
      console.log('Calendly script loaded successfully');
      setCalendlyReady(true);
    };

    script.onerror = (err) => {
      console.error('Failed to load Calendly script', err);
    };

    document.body.appendChild(script);

    const handleCalendlyEvent = (e) => {
      if (e.data.event && e.data.event.indexOf('calendly') === 0) {
        console.log('Calendly event:', e.data.event);
        
        if (e.data.event === 'calendly.event_scheduled') {
          console.log('Booking scheduled:', e.data.payload);
          onBookingScheduled(field.id, {
            eventUri: e.data.payload.event.uri,
            inviteeUri: e.data.payload.invitee.uri,
            scheduledAt: new Date().toISOString(),
          });
        }
      }
    };

    window.addEventListener('message', handleCalendlyEvent);

    return () => {
      window.removeEventListener('message', handleCalendlyEvent);
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
      if (link.parentNode) {
        link.parentNode.removeChild(link);
      }
    };
  }, [field.id, onBookingScheduled]);

  const openCalendly = (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    console.log('=== Calendly Button Clicked ===');
    console.log('calendlyReady:', calendlyReady);
    console.log('window.Calendly:', window.Calendly);
    console.log('isMobile:', isMobile);
    console.log('field.calendlyUrl:', field.calendlyUrl);
    
    if (!calendlyReady || !window.Calendly) {
      console.error('Calendly not ready!');
      alert('Calendly is still loading, please try again.');
      return;
    }

    // On mobile, redirect to Calendly URL with prefill params
    if (isMobile) {
      console.log('Mobile detected - redirecting to Calendly URL');
      console.log('Name:', name);
      console.log('Email:', email);
      console.log('Phone:', phone);
      console.log('Address:', address);
      
      // Build URL with query parameters
      const calendlyUrl = new URL(field.calendlyUrl);
      if (name) calendlyUrl.searchParams.set('name', name);
      if (email) calendlyUrl.searchParams.set('email', email);
      if (phone) calendlyUrl.searchParams.set('a1', phone);
      if (address) calendlyUrl.searchParams.set('a2', address);
      
      console.log('Redirecting to:', calendlyUrl.toString());
      
      // Open in new tab
      window.open(calendlyUrl.toString(), '_blank');
    } else {
      // Desktop - use popup
      console.log('Desktop detected - showing popup widget');
      console.log('Calling initPopupWidget with:', {
        url: field.calendlyUrl,
        prefill: {
          name: name || '',
          email: email || '',
          customAnswers: {
            a1: phone || '',
            a2: address || ''
          }
        },
        utm: {
          utmSource: formId || '' 
        }
      });
      
      try {
        window.Calendly.initPopupWidget({
          url: field.calendlyUrl,
          prefill: {
            name: name || '',
            email: email || '',
            customAnswers: {
              a1: phone || '',
              a2: address || ''
            }
          }
        });
        console.log('initPopupWidget called successfully');
      } catch (error) {
        console.error('Error calling initPopupWidget:', error);
      }
    }
  };

  return (
    <div
      style={{
        padding: '20px',
        border: '1px solid #e0e0e0',
        borderRadius: '8px',
        backgroundColor: '#f9f9f9',
      }}
    >
      <div style={{ marginBottom: '12px', fontWeight: 'bold', fontSize: '16px' }}>
        📅 {field.label}
      </div>
      {field.description && (
        <div style={{ marginBottom: '16px', color: '#666', fontSize: '14px' }}>
          {field.description}
        </div>
      )}
      
      <button
        type="button"
        onClick={openCalendly}
        disabled={!calendlyReady}
        style={{
          padding: '12px 24px',
          backgroundColor: calendlyReady ? '#0069ff' : '#ccc',
          color: 'white',
          border: 'none',
          borderRadius: '6px',
          cursor: calendlyReady ? 'pointer' : 'not-allowed',
          fontSize: '16px',
          fontWeight: '500',
          transition: 'transform 0.2s, background-color 0.2s',
        }}
        onMouseOver={(e) => calendlyReady && (e.target.style.transform = 'scale(1.05)')}
        onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
      >
        {calendlyReady ? 'Schedule Appointment' : 'Loading...'}
      </button>
    </div>
  );
}

export default CalendlyField;